const SolidButton = ({ children, className, ...others }) => {
  return (
    <a
      {...others}
      className={`border border-cyan-300 py-1 md:py-2 px-3 md:px-5 rounded-lg bg-cyan-300 text-gray-800 hover:bg-cyan-500 ${className}`}
    >
      {children}
    </a>
  );
};

export default SolidButton;